import { DatePipe } from '@angular/common';
import { LocalizationModule } from '@abp/ng.core';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Small presentational line shown at the bottom-right of a planning card: `Souhaité : <date>`.
 * Rendered red + bold when the desired date is critical for the card's placement, grey + bold otherwise
 * (the board shell precomputes criticality and feeds it via {@link critical}). Hidden when there's no date.
 */
@Component({
  selector: 'document-planning-desired-date',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, LocalizationModule],
  template: `
    @if (date(); as date) {
      <span class="planning-desired" [class.planning-desired--critical]="critical()">
        {{ 'Doc::Planning:CardField:Desired' | abpLocalization }} : {{ date | date: 'd MMM y' }}
      </span>
    }
  `,
  styles: [
    `
      .planning-desired {
        font-weight: 700;
        white-space: nowrap;
        font-size: var(--kanban-fs-11, 11px);
        color: var(--kanban-text-2, var(--bs-gray-600, #6c757d));
      }
      .planning-desired--critical {
        color: var(--bs-danger, #dc3545);
      }
    `,
  ],
})
export class PlanningDesiredDateComponent {
  /** The desired (requested) date, ISO string; the line is hidden when absent. */
  protected readonly date = input<string>();
  /** When true, render red + bold (critical); otherwise grey + bold. */
  protected readonly critical = input(false);
}
